import { ReactNode, createContext, useState } from 'react';

export interface FormContextProps {
    formData: Record<string, unknown>;
    updateFormData: (newData: Record<string, unknown>) => void;
    resetForm: () => void;
}

export const FormContext = createContext<FormContextProps | undefined>(undefined);

export const FormProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [formData, setFormData] = useState<Record<string, unknown>>({});

    const updateFormData = (newData: Record<string, unknown>) => {
        setFormData(prev => ({ ...prev, ...newData }));
    };

    const resetForm = () => setFormData({});

    return <FormContext.Provider value={{ formData, updateFormData, resetForm }}>{children}</FormContext.Provider>;
};
